export default __webpack_public_path__ + "static/media/Logo.e3006986.png";